import React, { useContext } from 'react'

import PanelHeader from '../../../../elem/panel/PanelHeader'
import { DataContext } from './DataContext'
import ResetDropdownButton from '../../../../elem/chart/ResetDropDownButton'
import SelectorButton from '../../../../elem/chart/SelectorButton'
import CollapseButton from '../../../../elem/list/CollapseButton'
import ExpandButton from '../../../../elem/list/ExpandButton'
import { PanelStyleContext } from '../../../../elem/panel/PanelStyleContext'

export default () => {
    const {
        displayMeasureWindowDropdown,
        toggleMeasureWindowDropdown,
        measureList,
        toggleResetExpanded,
        resetExpanded,
        setCollapsed,
        isCollapsed,
        displayGroupingWindowDropdown,
        toggleGroupingWindowDropdown,
    } = useContext(DataContext)

    const { isExpanded, setIsExpanded } = useContext(PanelStyleContext)

    return (
        <PanelHeader extraClass={'aggregatePanelHeader'}>
            <div className="panelHeaderText">Aggregate Pressure-Volume Chart</div>
            <div className="panelButtons">
                <ResetDropdownButton resetExpanded={resetExpanded} toggleResetExpanded={toggleResetExpanded} />
                {measureList && measureList.length ? (<>
                    <SelectorButton
                        displayWindowDropdown={displayGroupingWindowDropdown}
                        toggleWindowDropdown={toggleGroupingWindowDropdown}
                        label={`Report Grouping`}
                    />
                    <SelectorButton
                        displayWindowDropdown={displayMeasureWindowDropdown}
                        toggleWindowDropdown={toggleMeasureWindowDropdown}
                        label={`Measures`}
                    />
                </>) : null}
                <div className="panelHeaderIconWrapper">
                    {isExpanded ? null : (
                        <CollapseButton
                            name={`pressure-aggregate`}
                            isCollapsed={isCollapsed}
                            setIsCollapsed={setCollapsed}
                        />
                    )}
                    <ExpandButton
                        name={`pressure-aggregate`}
                        isExpanded={isExpanded}
                        setIsExpanded={setIsExpanded}
                    />
                </div>
            </div>
        </PanelHeader>
    )
}
